import { useLingui } from "@lingui/react";
import { CloudDownload, CloudUpload, Share2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SectionedMenuContent } from "@/components/ui/sectioned-menu";

interface RecipesMoreMenuProps {
  children: React.ReactNode;
  onExport?: () => void;
  onImport?: () => void;
  onShare?: () => void;
}

export function RecipesMoreMenu({
  children,
  onExport,
  onImport,
  onShare,
}: RecipesMoreMenuProps) {
  const { i18n } = useLingui();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-60 border-0 p-[5px] shadow-[0_24px_48px_-12px_rgba(16,24,40,0.18)]"
      >
        <SectionedMenuContent
          sections={[
            {
              label: i18n._("Actions"),
              items: [
                {
                  icon: <CloudDownload className="size-4" />,
                  label: i18n._("Export"),
                  onClick: onExport,
                },
                // No handler, no entry: Import creates recipes, which Working
                // mode does not allow (YC-33).
                ...(onImport
                  ? [
                      {
                        icon: <CloudUpload className="size-4" />,
                        label: i18n._("Import"),
                        onClick: onImport,
                      },
                    ]
                  : []),
                {
                  icon: <Share2 className="size-4" />,
                  label: i18n._("Share"),
                  onClick: onShare,
                },
              ],
            },
          ]}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
